module.exports = __webpack_public_path__ + "img/Weapon_208.a4b0cc1a.png";